import React from 'react'
import { withStyles } from '@material-ui/core/styles'

import styles from './styles'

const Imager = withStyles(styles)(props => {
  const { contents, type, inc, count, classes } = props
  const data = contents.filter(x => x.type === type)[count[type]].content.items[0]
  inc(type)
  return (
    data && (
      <div
        className={classes.contenterImage}
        style={{
          backgroundImage: `url(${
            data.image.localFile.childImageSharp.original.src
          })`,
        }}
      />
    )
  )
})

export default withStyles(styles)(Imager)



// WEBPACK FOOTER //
// ./src/components/scaffolding/widgets/imager.js